import { createAction } from "@reduxjs/toolkit";
import { generateUUID } from "utils/appUtil";

export const GET_RX = createAction("GET_RX");
export const GET_VIDEO_SNAPSHOT = createAction("GET_VIDEO_SNAPSHOT");
export const GET_HISTORICAL_GPS = createAction("GET_HISTORICAL_GPS");
export const ADD_IMEI_SUBSCRIPTION = createAction("ADD_IMEI_SUBSCRIPTION");
export const CLEAR_ALL_IMEI_SUBSCRIPTION = createAction(
  "CLEAR_ALL_IMEI_SUBSCRIPTION"
);
export const REMOVE_IMEI_SUBSCRIPTION = createAction(
  "REMOVE_IMEI_SUBSCRIPTION"
);
export const ADD_MAP_PEOPLES = createAction("ADD_MAP_PEOPLES");
export const GET_MAP_PLACES_BOUNDS = createAction("GET_MAP_PLACES_BOUNDS");
export const GET_MAP_PLACES_FILTER = createAction("GET_MAP_PLACES_FILTER");
export const GET_PAGE_PLACES_FILTER = createAction("GET_PAGE_PLACES_FILTER");
export const SET_SELECTED_PLACES = createAction("SET_SELECTED_PLACES");
export const SET_PLACES = createAction("SET_PLACES");
export const GET_LOCATION_PROFILES = createAction("GET_LOCATION_PROFILES");
export const GET_PROJECT_LIST = createAction("getProjectList");
export const GET_ADMIN_ROLES_LIST = createAction("getAdminRolesList");

const initialState = {
  gps: {},
  subscriptions: [],
  places: { items: [], page: 0, pagination: true, searching: false },
  assets: { items: [], page: 0, pagination: true, searching: false },
  medias: { items: [], page: 0, pagination: true, searching: false },
  pages: { items: [], page: 0, pagination: true, searching: false },
  peoples: { items: [], page: 0, pagination: true, searching: false },
  gpss: { items: [], page: 0, pagination: true, searching: false },
  events: { items: [], page: 0, pagination: true, searching: false },
  selected_places: { items: [], fitBounds: false },
  mode: "multi",
  selectedFilter: undefined,
  enabledFilter: [],
  mapBounds: undefined,
  requestIds: {
    user: generateUUID(),
    log: generateUUID(),
    page: generateUUID(),
    message: generateUUID(),
  }
};

const setHistoricalGPS = (
  state: DashboardState,
  action: any
): DashboardState => {
  const { response, live, imei, messageId } = action.payload;
  console.log("response here", response);
  // const temp = {
  //   data: [
  //     {
  //         "samples": [
  //             {
  //                 "timestamp": 1652117211589,
  //                 "dataset": {
  //                     "location": {
  //                         "lat": 31.53566,
  //                         "long": 74.414459
  //                     },
  //                     "speed": 15.035895302761054,
  //                     "alt": 160.0109100341797,
  //                     "heading": 340.69219970703125
  //                 }
  //             }
  //         ]
  //     }
  // ]
  // };

  let points = response?.data?.[0]?.samples ?? [];
  points = points.filter((x) => {
    return x.dataset.locationGps !== undefined;
  });
  // points.sort((a,b) => (a.timestamp < b.timestamp) ? 1 : ((b.timestamp < a.timestamp) ? -1 : 0));

  // console.log('points', points?.[0]?.timestamp, points?.[1]?.timestamp);
  points.reverse();
  // points = points.slice(0, 100);
  return {
    ...state,
    gps: { points, live, imei, messageId },
    // gps: { points: [], live, imei },
  };
};

const setRx = (state: DashboardState, action: any): DashboardState => {
  return {
    ...state,
    rx: action.payload,
  };
};

const setSnapshotUrl = (state: DashboardState, action: any): DashboardState => {
  return {
    ...state,
    snapshotUrl: action.payload,
  };
};

const clearRx = (state: DashboardState): DashboardState => {
  return {
    ...state,
    rx: [],
  };
};

const setMapPlacesBounds = (
  state: DashboardState,
  action: any
): DashboardState => {

  let places = action.payload.map((temp) => {
    // const temp = place?.[Object.keys(place)?.[0]]?.[0]?.[0];
    let objectType = temp?.geoJson?.features?.[0]?.id.split(":")[0];
    let imei = {};
    // const id = temp.objectId.split(":")[1];
    const id = temp.objectIds?.[0];
    const tags = temp?.geoJson?.features?.[0]?.properties?.source?.clbs?.tags || [];
    if(objectType === 'medium'){
      objectType = "media";
    }
    if (objectType === "iot") {
      objectType = "gps";
      // const segments = temp.objectId.split(":");
      const segments = temp.objectIds?.[0].split(":");
      imei = {
        // objectId: temp.objectId,
        objectId: temp.objectIds?.[0],
        iotUdid: segments?.[1],
        iotUserId: segments?.[2],
        userId: segments?.[3],
        imei: `${process.env.REACT_APP_ECO_SYSTEM}/device/${segments?.[1]}/user/${segments?.[3]}/iotAppend/${segments?.[2]}/gps`,
        timestamp: temp?.geoJson?.features?.[0]?.properties?.timestamp,
        id: segments?.[3],
      };
      // tags.push(`name:${segments?.[3]}`)
    }
    let name = "";
    tags?.map((tag) => {
      if (tag.includes("name")) {
        name = tag.replace("name:", "");
      }
    });
    if(name === undefined || name === ''){
      name = id
    }
    return {
      objectType,
      location: temp?.geoJson?.features?.[0]?.geometry,
      id,
      tags,
      fullObj: temp,
      name,
      ...imei
    };
  });

  places = places.filter(
    (value, index, self) => index === self.findIndex((t) => t.id === value.id)
  );

  places = places.filter(
    (value, index, self) => value.tags && value.tags.length > 1
  );

  console.log("places here", places);

  // let places = action.payload;

  return {
    ...state,
    map_places_bounds: places,
    places: { ...state.places, items: places, pagination: false },
    selected_places: { items: places, fitBounds: false },
  };
};

const setMapPlacesFilter = (
  state: DashboardState,
  action: any
): DashboardState => {
  return {
    ...state,
    map_places_filter: action.payload,
  };
};

const setMapAssetsFilter = (
  state: DashboardState,
  action: any
): DashboardState => {
  return {
    ...state,
    map_assets_filter: action.payload,
  };
};

const setMapPagesFilter = (
  state: DashboardState,
  action: any
): DashboardState => {
  return {
    ...state,
    map_pages_filter: action.payload,
  };
};

const setMapGpsFilter = (
  state: DashboardState,
  action: any
): DashboardState => {
  return {
    ...state,
    map_gpss_filter: action.payload,
  };
};

const setMapEventFilter = (
  state: DashboardState,
  action: any
): DashboardState => {
  return {
    ...state,
    map_events_filter: action.payload,
  };
};

const setMapMediasFilter = (
  state: DashboardState,
  action: any
): DashboardState => {
  return {
    ...state,
    map_medias_filter: action.payload,
  };
};

const setMapPeoplesFilter = (
  state: DashboardState,
  action: any
): DashboardState => {
  // })
  return {
    ...state,
    map_peoples_filter: action.payload,
  };
};

const addImeiSubscription = (
  state: DashboardState,
  action: any
): DashboardState => {
  const { imei } = action.payload;
  const prevSubscriptions = [...(state.subscriptions || [])];
  let index = prevSubscriptions.findIndex((x) => {
    return x === imei;
  });
  if (index === -1) prevSubscriptions.push(imei);
  return {
    ...state,
    subscriptions: prevSubscriptions,
  };
};

const removeImeiSubscription = (
  state: DashboardState,
  action: any
): DashboardState => {
  const { imei } = action.payload;
  const prevSubscriptions = [...(state.subscriptions || [])];
  let index = prevSubscriptions.findIndex((x) => {
    return x === imei;
  });
  if (index !== -1) prevSubscriptions.splice(index, 1);
  return {
    ...state,
    subscriptions: prevSubscriptions,
  };
};

const clearAllSubscription = (state: DashboardState): DashboardState => {
  return {
    ...state,
    subscriptions: [],
    gps: {},
  };
};

const clearAllFilters = (state: DashboardState): DashboardState => {
  return {
    ...state,
    places: { items: [], page: 0, pagination: true, searching: false },
    assets: { items: [], page: 0, pagination: true, searching: false },
    medias: { items: [], page: 0, pagination: true, searching: false },
    pages: { items: [], page: 0, pagination: true, searching: false },
    peoples: { items: [], page: 0, pagination: true, searching: false },
    gpss: { items: [], page: 0, pagination: true, searching: false },
    events: { items: [], page: 0, pagination: true, searching: false },
    selected_places: { items: [], fitBounds: false },
    enabledFilter: [],
    selectedFilter: undefined,
  };
};

const setSelectedPlaces = (
  state: DashboardState,
  action: any
): DashboardState => {
  return {
    ...state,
    selected_places: action.payload,
  };
};

const addSelectedPlaces = (
  state: DashboardState,
  action: any
): DashboardState => {
  let selected_places = {
    items: [...(state.selected_places?.items || [])],
    fitBounds: true,
  };
  const message = action.payload;
  // const { flag } = message.data;
  const flag = action.payload.refMessage?.referenceType;

  if (flag === "update") {
    let index = selected_places.items.findIndex((x) => {
      return (
        x.id === message.originalPageMessageId ||
        x.originalPageMessageId === message.originalPageMessageId
      );
    });
    if (index !== -1) {
      selected_places.items[index] = {
        ...message,
        id: message.id,
        name: message.message,
        objectType: "place",
      };
      return {
        ...state,
        selected_places,
      };
    }
  } else if (flag === "remove") {
    let index = selected_places.items.findIndex((x) => {
      return (
        x.id === message.originalPageMessageId ||
        x.originalPageMessageId === message.originalPageMessageId
      );
    });
    if (index !== -1) {
      selected_places.items.splice(index, 1);
      return {
        ...state,
        selected_places: { ...selected_places },
      };
    }
  }

  if (
    selected_places.items.filter((e) => {
      return e.id === action.payload.id;
    }).length !== 0
  ) {
    return {
      ...state,
    };
  } else {
    if (state.mode === "single") {
      selected_places.items = [action.payload];
    } else {
      selected_places.items.push(action.payload);
    }

    return {
      ...state,
      selected_places,
    };
  }
};

const removeSelectedPlaces = (
  state: DashboardState,
  action: any
): DashboardState => {
  let selected_places = {
    items: [...(state.selected_places?.items || [])],
    fitBounds: true,
  };
  const message = action.payload;
  let index = selected_places.items.findIndex((x) => {
    return (
      // x.data.iotUserId === message.data.iotUserId &&
      // x.data.iotUdid === message.data.iotUdid

      x.id === message.originalPageMessageId ||
      x.originalPageMessageId === message.originalPageMessageId ||
      x.id === message.refMessage.pageMessageId

    );
  });

  console.log('remove index', index);
  console.log('yo man here', message, selected_places)

  if (index !== -1) {
    selected_places.items.splice(index, 1);
    return {
      ...state,
      selected_places: { ...selected_places },
    };
  }
  else{
    return {
      ...state,
    };
  }
};

const setPlaces = (state: DashboardState, action: any): DashboardState => {
  return {
    ...state,
    places: {
      ...state.places,
      ...action.payload,
    },
  };
};

const setAssets = (state: DashboardState, action: any): DashboardState => {
  return {
    ...state,
    assets: {
      ...state.assets,
      ...action.payload,
    },
  };
};

const setPeoples = (state: DashboardState, action: any): DashboardState => {
  return {
    ...state,
    peoples: {
      ...state.peoples,
      ...action.payload,
    },
  };
};

const setPages = (state: DashboardState, action: any): DashboardState => {
  return {
    ...state,
    pages: {
      ...state.pages,
      ...action.payload,
    },
  };
};

const setGpss = (state: DashboardState, action: any): DashboardState => {
  return {
    ...state,
    gpss: {
      ...state.gpss,
      ...action.payload,
    },
  };
};

const setEvents = (state: DashboardState, action: any): DashboardState => {
  return {
    ...state,
    events: {
      ...state.events,
      ...action.payload,
    },
  };
};

const setMedias = (state: DashboardState, action: any): DashboardState => {
  return {
    ...state,
    medias: {
      ...state.medias,
      ...action.payload,
    },
  };
};

const setLocationProfiles = (
  state: DashboardState,
  action: any
): DashboardState => {
  return {
    ...state,
    location_profiles: action.payload?.[0]?.[0],
  };
};

const addPageGroup = (state: DashboardState, action: any): DashboardState => {
  return {
    ...state,
    page_group: action.payload,
  };
};

const setMapMode = (state: DashboardState, action: any): DashboardState => {
  return {
    ...state,
    mode: action.payload,
    selected_places:
      action.payload === "single"
        ? { items: [], fitBounds: false }
        : state.selected_places,
  };
};

const setEditPlace = (state: DashboardState, action: any): DashboardState => {
  return {
    ...state,
    edit_place: action.payload,
  };
};

const setSelectedFilter = (
  state: DashboardState,
  action: any
): DashboardState => {
  return {
    ...state,
    selectedFilter: action.payload,
  };
};

const setEnabledFilter = (
  state: DashboardState,
  action: any
): DashboardState => {
  return {
    ...state,
    enabledFilter: action.payload,
  };
};

const setMapBounds = (
  state: DashboardState,
  action: any
): DashboardState => {
  return {
    ...state,
    mapBounds: action.payload,
  };
};

const getProjectList = (state: any, action: any): any => {
  return {
    ...state,
    projects: action.payload || [],
  };
};

const getAdminRolesList = (state: any, action: any): any => {
  return {
    ...state,
    adminRoles: action.payload || [],
  };
};

const dashboardReducer = (
  state: DashboardState = initialState,
  action: any
): DashboardState => {
  switch (action.type) {
    case "ADD_IMEI_SUBSCRIPTION":
      return addImeiSubscription(state, action);
    case "REMOVE_IMEI_SUBSCRIPTION":
      return removeImeiSubscription(state, action);
    case "CLEAR_ALL_IMEI_SUBSCRIPTION":
      return clearAllSubscription(state);
    case "ADD_GPS":
      return setHistoricalGPS(state, action);
    case "ADD_RX":
      return setRx(state, action);
    case "ADD_VIDEO_SNAPSHOT":
      return setSnapshotUrl(state, action);
    case "ADD_MAP_PLACES_BOUNDS":
      return setMapPlacesBounds(state, action);
    case "ADD_MAP_PLACE_FILTER":
      return setMapPlacesFilter(state, action);
    case "ADD_MAP_ASSET_FILTER":
      return setMapAssetsFilter(state, action);
    case "ADD_MAP_USER_FILTER":
      return setMapPeoplesFilter(state, action);
    case "ADD_MAP_MEDIA_FILTER":
      return setMapMediasFilter(state, action);
    case "ADD_MAP_PAGE_FILTER":
      return setMapPagesFilter(state, action);
    case "ADD_MAP_GPS_FILTER":
      return setMapGpsFilter(state, action);
    case "ADD_MAP_EVENT_FILTER":
      return setMapEventFilter(state, action);
    case "GET_RX":
      return clearRx(state);
    case "SET_SELECTED_PLACES":
      return setSelectedPlaces(state, action);
    case "ADD_SELECTED_PLACES":
      return addSelectedPlaces(state, action);
    case "REMOVE_SELECTED_PLACES":
      return removeSelectedPlaces(state, action);  
    case "SET_PLACES":
      return setPlaces(state, action);
    case "SET_ASSETS":
      return setAssets(state, action);
    case "SET_PEOPLES":
      return setPeoples(state, action);
    case "SET_MEDIAS":
      return setMedias(state, action);
    case "SET_PAGES":
      return setPages(state, action);
    case "SET_GPSS":
      return setGpss(state, action);
    case "SET_EVENTS":
      return setEvents(state, action);
    case "SET_LOCATION_PROFILES":
      return setLocationProfiles(state, action);
    case "CLEAR_ALL_FILTERS":
      return clearAllFilters(state);
    case "ADD_PAGE_GROUP":
      return addPageGroup(state, action);
    case "SET_MAP_MODE":
      return setMapMode(state, action);
    case "EDIT_PLACE":
      return setEditPlace(state, action);
    case "SET_SELECTED_FILTER":
      return setSelectedFilter(state, action);
    case "SET_ENABLED_FILTER":
      return setEnabledFilter(state, action);
    case GET_PROJECT_LIST:
      return getProjectList(state, action);
    case GET_ADMIN_ROLES_LIST:
      return getAdminRolesList(state, action);
    default:
      return state;
    case "SET_MAP_BOUNDS":
      return setMapBounds(state, action);
  }
};

export default dashboardReducer;
